<template>
  <div class="remark m-b-100">
    <div class="remark-detail" v-if="projectDetail">
      <Row type="flex" justify="center" class="status" style="margin-bottom:15px;">
        <Col span="24" class="txt" style="margin-bootm:15px;">
          <i
            class="iconfont icon-shixinshoucang"
            :class="projectDetail.isOpen === 0 ? 'closed-i': ''"
          ></i>
          <span>项目状态： {{projectDetail.isOpen === 1 ? '活跃' : '关闭'}}</span>
        </Col>
      </Row>
      <Row :gutter="50" type="flex" justify="start" class="status">
        <Col class="txt" v-if="projectDetail.type === 2">
          <span>主管理员： {{projectDetail.loginName}}</span>
        </Col>
        <Col class="txt">
          <span>创建时间： {{projectDetail.createTime | date}}</span>
        </Col>
      </Row>
      <Row :gutter="50" type="flex" justify="start" class="status">
        <Col class="txt">
          <span v-if="projectDetail.type === 2">项目类型：企业项目（{{projectDetail.companyName}}）</span>
          <span v-if="projectDetail.type === 1">项目类型：个人项目</span>
        </Col>
      </Row>
      <Row :gutter="50" type="flex" justify="start" class="status">
        <Col class="txt">
          <span>项目所在地：{{getAddress(projectDetail.locationId, 'second')}}</span>
        </Col>
      </Row>
      <Row :gutter="50" type="flex" justify="start" class="status">
        <Col class="txt">
          <span>项目描述：{{projectDetail.remark || '暂无'}}</span>
        </Col>
      </Row>
      <Row v-if="projectDetail.type === 2" :gutter="10" type="flex" justify="start" class="status">
        <Col class="txt">
          <span>项目成员：</span>
        </Col>
        <Col class="txt" v-if="group_list && group_list.length > 0">
          <Avatar
            v-if="index <= 4"
            style="margin-right:5px;"
            v-for="(item, index) in group_list"
            :key="index"
            icon="ios-person"
            :src="item.avatarFile && ossPrefix + item.avatarFile.key"
            size="small"
          />
        </Col>
        <Col class="txt omit" v-if="group_list && group_list.length >= 5">
          <i class="iconfont icon-other"></i>
        </Col>
        <Col class="txt" v-if="group_list && group_list.length > 0">
          <span class="small">共{{group_list.length}}人</span>
        </Col>
        <Col class="txt team-edit" v-if="permissionFuc('project:team:add')">
          <i @click="addPeojectHandle" class="iconfont icon-bianjicopy"></i>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Promise, reject } from "q";
import { permissionFuc } from "@/utils/permissions.js";
import { getAddress, downloadURI } from "@/utils";
export default {
  name: "Remark",
  data() {
    return {
      VUE_APP_OLD_BASIC_URL: process.env.VUE_APP_OLD_BASIC_URL,
      dialogDelete: true,
      model_loading: true,
      permissionFuc: permissionFuc,
      getAddress: getAddress,
      projectDetail: ""
    };
  },

  computed: {
    group_list() {
      return this.$store.state.group_list;
    },
    permission() {
      return this.$store.state.permission;
    }
  },

  methods: {
    /* 请求详情 */
    getProjectDetail() {
      axios
        .get(`/designer_api/projects/${this.$route.params.id}`, {
          globalLoading: true
        })
        .then(res => {
          this.projectDetail = res;
          this.$store.dispatch("getProjectDetails", res);
        });
    },
    /* 添加项目成员 */
    addPeojectHandle() {
      this.$router.push({
        name: "Team",
        params: { id: this.$route.params.id },
        query: { locationId: this.$route.query.locationId }
      });
    }
  },

  created() {
    this.getProjectDetail();
    this.$on("global:getProject", () => {
      this.getProjectDetail();
    });
  }
};
</script>

<style lang="scss" scoped>
.remark {
  max-width: 500px;
  max-width: 1200px;

  .remark-detail {
    width: 100%;
    background: rgba(246, 246, 246, 1);
    border-radius: 4px;
    padding: 30px;
    margin-top: 40px;
    .status {
      margin-bottom: 20px;
      .txt {
        i {
          font-size: 22px;
          color: #e56a69;
          margin-right: 5px;
          vertical-align: middle;
        }
        i.closed-i {
          color: #313131;
        }
        > span {
          font-size: 16px;
          font-weight: 500;
          color: rgba(49, 49, 49, 1);
        }
        .small {
          font-size: 16px;
          font-weight: 500;
          color: #707070;
        }
      }
      .omit {
        i {
          margin-top: -6px;
          display: inline-block;
          color: #ccc;
          font-size: 24px;
        }
      }
      .team-edit {
        i {
          font-size: 18px;
          color: #707070;
          cursor: pointer;
          vertical-align: top;
          &:hover {
            color: #e56a69;
          }
        }
      }
      .btn {
        i {
          font-size: 23px;
          color: #707070;
          cursor: pointer;
          margin-top: -4px;
          display: inline-block;
          &:hover {
            color: #e56a69;
          }
        }
        text-align: right;
      }
    }
  }
}
</style>

<style lang="scss">
.delete-dialog {
  p {
    margin-bottom: 10px;
    i.dialog-content-error {
      color: #e56a69;
      font-size: 16px;
      vertical-align: middle;
      display: inline-block;
      margin-right: 5px;
    }
  }
}
.projectSwitch {
  p {
    color: #313131;
    text-align: center;
    margin-bottom: 10px;
    i {
      color: #e56a69;
      font-size: 50px;
    }
  }
}
.Checkbox-chioceding {
  .ivu-checkbox-inner {
    border-radius: 50%;
  }
}
.Checkbox-chioced {
  .ivu-checkbox-inner {
    background: #313131;
  }
}
</style>


